import * as React from 'react';
import { createPortal } from 'react-dom';
import api from '../../../api';
import { isModalShowable, storeLocallyCloseModalDate } from './helpers';
import { GradientLeft, GradientRight, ModalContent, ModalTitle, StyledModal, StyledParagraph } from './HighBlockedDaysModal.styled';

export interface ICalendarModalProps {
	propertyId: string | number | undefined;
}

export const HighBlockedDaysModal: React.FC<ICalendarModalProps> = (props) => {
	const { propertyId } = props;

	const [showCalendarModal, setShowCalendarModal] = React.useState(false);

	React.useEffect(() => {
		const updateModalVisibility = async () => {
			const availabilityValidation = await api.client.getAvailabilityValidity(propertyId);
			setShowCalendarModal(isModalShowable(propertyId, availabilityValidation));
		};
		updateModalVisibility().catch();
	}, [propertyId]);

	const modalClosedOnProperty = (id: string | number | undefined) => {
		setShowCalendarModal(false);
		storeLocallyCloseModalDate(id);
	};

	return createPortal(
		<StyledModal
			cancelButton={{
				text: 'Dismiss',
				onClick: () => modalClosedOnProperty(propertyId)
			}}
			onBackgroundClick={() => modalClosedOnProperty(propertyId)}
			show={showCalendarModal}
			closeButton={{ onClick: () => modalClosedOnProperty(propertyId) }}
		>
			<img src="/92b3b47/assets/icons/calendar/calendar-cropped.svg" alt="" />
			<GradientLeft/>
			<GradientRight/>
			<ModalContent className={showCalendarModal ? 'modal-visible' : ''}>
				{/* this classname added for ease of testing */}
				<ModalTitle type="IB110" lineHeight="sm" htmlElement="h4">{`More than 50% of your available dates are blocked`}</ModalTitle>
				<StyledParagraph type="IR100" lineHeight="md">
					{`Lack of availability can hurt your performance on channels. Try and remove your calendar blocks at your earliest convenience.`}
				</StyledParagraph>
			</ModalContent>
		</StyledModal>,
		document.body
	);
};
